export default "assets/images/icons/chevron-074cf12c.svg";